export default "__VITE_ASSET__0773fb1a__"